import axios from 'axios';

const model = 'Asignatura'
const API_URL = process.env.VUE_APP_API_URL;

export default {
  get() {
    return axios.get(`${API_URL}/${model}/v1/list`);
  },

}